import { Link, Box, Skeleton, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

const AnalyticItem = ({
  label,
  icon,
  value,
  isLoading,
  link,
}: {
  label: string;
  icon: JSX.Element;
  value: number;
  isLoading: boolean;
  link?: string;
}) => {
  const navigate = useNavigate();
  return (
    <Box component="li" sx={{ display: "flex", justifyContent: "space-between" }}>
      <Box sx={{ display: "flex", gap: "10px" }}>
        {icon}
        {link ? (
          <Link
            variant="body14Regular"
            sx={{
              textDecoration: "none",
              cursor: "pointer",
            }}
            onClick={() => navigate(link)}
          >
            {label}
          </Link>
        ) : (
          <Typography variant="body14Regular">{label}</Typography>
        )}
      </Box>

      <Typography variant="body14Regular">
        {isLoading ? <Skeleton variant="text" animation="wave" width={20} /> : value}
      </Typography>
    </Box>
  );
};

export default AnalyticItem;
